import CrudCustom from '../../../libs/custom/CrudCustom';


let DetailModalService = new CrudCustom('/detail-modals');
export default DetailModalService;
